import { render, staticRenderFns } from "./CreatedLeads.vue?vue&type=template&id=54d0f062&scoped=true&"
import script from "./CreatedLeads.vue?vue&type=script&lang=js&"
export * from "./CreatedLeads.vue?vue&type=script&lang=js&"
import style0 from "./CreatedLeads.vue?vue&type=style&index=0&id=54d0f062&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0f062",
  null
  
)

export default component.exports